export default "__VITE_ASSET__CWKhIMR1__"